import { toDateValue } from '@pos/admin-ui';
import type { ApiProblem } from '@pos/api-client';
import { useState } from 'react';

/** Where the HO reports are (ADR 0097). */
export const REPORT_PATHS = {
  sales: '/reports/sales',
  products: '/reports/products',
  hours: '/reports/hours',
  payments: '/reports/payments',
  qr: '/reports/qr-reconciliation',
  controls: '/reports/voids-discounts',
  journal: '/reports/sales-journal',
  einvoices: '/reports/einvoice-reconciliation',
  menu: '/reports/menu-engineering',
  staff: '/reports/staff',
  operations: '/reports/operations',
  customers: '/reports/customers',
} as const;

/** What every HO report is asked for (ADR 0097): a date range of at most 400 days, and all stores or one. */
export interface ReportRange {
  from: string;
  to: string;
  storeId: string;
}

/** The last 7 days, today included. */
export function defaultRange(): ReportRange {
  const today = new Date();
  const start = new Date(today);
  start.setDate(today.getDate() - 6);
  return { from: toDateValue(start), to: toDateValue(today), storeId: '' };
}

export function useReportRange() {
  return useState<ReportRange>(defaultRange);
}

/** The query every report endpoint takes. */
export const rangeQuery = (range: ReportRange) => ({
  from: range.from,
  to: range.to,
  ...(range.storeId ? { storeId: range.storeId } : {}),
});

export async function unwrap<T>(call: Promise<{ data?: T; error?: unknown }>): Promise<T> {
  const { data, error } = await call;
  if (error) throw error as ApiProblem;
  return data as T;
}
